import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport } from "vue"
import _imports_0 from '../../assets/icons/search-active.png'
import _imports_1 from '../../assets/icons/filter.png'
import _imports_2 from '../../assets/icons/gridView.png'
import _imports_3 from '../../assets/icons/listView.png'
import _imports_4 from '../../assets/icons/add.png'


const _hoisted_1 = { class: "main-container content-start mt-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "ac-large-title mb-0" }, "Fırsatlar", -1)
const _hoisted_3 = { class: "actions-row col-start-1 col-end-13 flex items-center justify-between gap-4" }
const _hoisted_4 = { class: "flex items-center gap-4" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Ara",
  class: "absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6 opacity-50"
}, null, -1)
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "filter-main",
  src: _imports_2,
  alt: "Filtrele"
}
const _hoisted_13 = {
  key: 1,
  class: "filter-main",
  src: _imports_3,
  alt: "Filtrele"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4 filter-main",
  width: "20",
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_17 = { class: "flex gap-2 overflow-x-scroll max-w-[20vw] overflow-x-bars-hidden" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "col-start-1 col-end-13 grid grid-cols-4 gap-8"
}

import type { AcPotential } from "@/types/crm"
import type { fetchedUser } from "@/types/fetchedUser"
import type { Ref } from 'vue'
import type { ColorMetaField } from "@/types/metas"
import { ref, computed } from "vue"
import { useStore } from 'vuex'
import { useGetDocs, useGetFilteredDocs, postData } from "@/mixins/modularFirebaseOperations"
import {formatUser, modalClosed} from "@/mixins/visualFormatters"
import { useRouter } from "vue-router"
import { movePotentialToTracked } from "@/composables/crmBasedFunctions"
import AcDataTable from "@/components/reusable/acDataTable.vue"
import StarDisplay from "@/components/reusable/starDisplay.vue"
import modernStatusChip from "@/components/reusable/modernStatusChip.vue"
import SkeletonTable from "@/components/reusable/skeletonTable.vue"
import filterPopup from "@/components/reusable/filterPopup.vue"
import CrmPotentialCard from "@/components/crm-components/potentialCard.vue"
import AcMediumModal from "@/components/reusable/teleports/acMediumModal.vue"
import AddPotentialForm from "@/components/crm-components/addPotentialForm.vue"



export default /*#__PURE__*/_defineComponent({
  __name: 'potentialsList',
  setup(__props) {


const isAddingPotential = ref(false)

const { docs, isLoadingDocs } = useGetFilteredDocs("crm/potentials/list", { status: "ACTIVE" })
const potentials = docs as Ref<AcPotential[]>
const router = useRouter()

// Get job categories for filtering
const { docs: categoryDocs } = useGetDocs("crm/jobCategories/list")
const jobCategories = categoryDocs as Ref<ColorMetaField[]>

// Search and filter state
const searchQuery = ref('')
const selectedCategoryFilter = ref<ColorMetaField | null>(null)
const isShowingCategoryFilter = ref(false)
const isShowingAssignedToMe = ref(false)
const store = useStore()
const userProfile = computed(() => store.getters['user/userProfile'])
const prefView = computed(() => userProfile.value?.preferences?.crmView || 'list')

const changeUserView = () => {
    if(prefView.value === 'list'){
        store.dispatch('user/changeCrmPreference', { key: 'crmView', value: 'card' })
    } else {
        store.dispatch('user/changeCrmPreference', { key: 'crmView', value: 'list' })
    }
}

// Handle category filter selection
const handleCategorySelected = (category: ColorMetaField | undefined) => {
    selectedCategoryFilter.value = category || null
}

const handleCategoryFilterClosed = () => {
    isShowingCategoryFilter.value = false
}

const user = userProfile.value

const handlePotentialAdded = async (potential: AcPotential) => {
    try{
        const finalPotential: AcPotential = {
            ...potential,
            createdAt: new Date(),
            updatedAt: {
                date: new Date(),
                user: formatUser(user),
            },
            addedBy: formatUser(user),
            status: "ACTIVE",
            assignedTo: [formatUser(user)],
            comments: [],

        }
        
        const newId = await postData(finalPotential, "crm/potentials/list")
        router.push(`/crm/potential-detail/${newId}`)
        
    } catch (error) {
        console.error(error)
    } finally {
        
        isAddingPotential.value = false
        modalClosed()
    }
}

// Filtered potentials based on search and category
const filteredPotentials = computed(() => {
    let filtered = potentials.value

    // Filter by search query
    if (searchQuery.value.trim()) {
        const query = searchQuery.value.toLowerCase().trim()
        filtered = filtered.filter(potential => 
            potential.title.toLowerCase().includes(query) ||
            potential.description?.toLowerCase().includes(query) ||
            potential.potentialCategories.some((cat: ColorMetaField) => cat.name?.toLowerCase().includes(query))
        )
    }

    // Filter by selected category
    if (selectedCategoryFilter.value) {
        filtered = filtered.filter(potential => 
            potential.potentialCategories.some((cat: ColorMetaField) => cat.id === selectedCategoryFilter.value?.id)
        )
    }

    // Filter by assigned to me
    if (isShowingAssignedToMe.value && user?.userId) {
        filtered = filtered.filter(potential => 
            potential.assignedTo?.some((assignedUser: fetchedUser) => assignedUser.id === user.userId)
        )
    }

    return filtered
})

const tableData = computed(() => {
    return filteredPotentials.value.map(doc => {
        const createdAtDate = doc.createdAt instanceof Date ? doc.createdAt : (doc.createdAt as any).toDate()
        return {
            id: doc.id, // Include the original id for navigation
            title: doc.title,
            categories: doc.potentialCategories,
            potentialRating: doc.potentialRating,
            createdAt: createdAtDate.toLocaleDateString("tr-TR"),
            actions: doc, // Include the full potential object for actions
        }
    })
})

const dataCols = [
    {
        title: "Fırsat Adı",
        key: "title",
        width: "20%",
        isSortable: true
    },
    {
        title: "Kategoriler",
        key: "categories",
        width: "20%",
        isSortable: true,
    },
    {
        title: "Oluşturulma Tarihi",
        key: "createdAt",
        width: "20%",
        isSortable: true
    },
    {
        title: "Fırsat Düzeyi",
        key: "potentialRating",
        width: "20%",
        isSortable: true,
    },
    {
        title: "İşlemler",
        key: "actions",
        width: "10%",
        isSortable: false,
    },

]

const navigateToPotential = (item: any) => {
    router.push(`/crm/potential-detail/${item.id}`)
}

const handlePotentialMovedToTracked = async (potential: AcPotential) => {
    const confirmation = confirm("Bu öge potansiyeller listesinden kaldırılarak takip listesine eklenecektir. İşlem tamamlandığında otomatik olarak Takip ekranına yönlendirileceksiniz.")
    console.log(confirmation)
    if(confirmation) {
        await movePotentialToTracked(potential, userProfile.value)
        router.push(`/crm/tracked-detail/${potential.id}`)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: "Fırsatlarda ara...",
            class: _normalizeClass(["px-12 py-3 opacity-50 text-2xl border border-gray-300 rounded-lg focus:outline-none min-w-[250px]", { '!opacity-100': searchQuery.value !== '' }])
          }, null, 2), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isShowingCategoryFilter.value = true), ["stop"])),
            class: _normalizeClass(["ac-add-button", { 'stateful-background': selectedCategoryFilter.value }])
          }, [
            _createElementVNode("img", {
              class: _normalizeClass({'filter-white': !selectedCategoryFilter.value}),
              src: _imports_1,
              alt: "Filtrele"
            }, null, 2),
            (selectedCategoryFilter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(selectedCategoryFilter.value.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, "Kategori"))
          ], 2),
          (isShowingCategoryFilter.value)
            ? (_openBlock(), _createBlock(filterPopup, {
                key: 0,
                onFilterClosed: handleCategoryFilterClosed,
                onItemSelected: handleCategorySelected,
                class: "absolute w-max",
                itemList: _unref(jobCategories),
                selectedItems: selectedCategoryFilter.value ? [selectedCategoryFilter.value] : [],
                "displayed-attribute": "name"
              }, null, 8, ["itemList", "selectedItems"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isShowingAssignedToMe.value = !isShowingAssignedToMe.value)),
          class: _normalizeClass(["ac-add-button", { 'stateful-background': isShowingAssignedToMe.value }])
        }, [
          _createElementVNode("img", {
            class: _normalizeClass({'filter-white': !isShowingAssignedToMe.value}),
            src: _imports_1,
            alt: "Bana Atananları Listele"
          }, null, 2),
          (isShowingAssignedToMe.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Bana Atananlar"))
            : (_openBlock(), _createElementBlock("span", _hoisted_11, "Bana Atananları Listele"))
        ], 2),
        _createElementVNode("div", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (changeUserView())),
          class: "ac-add-button"
        }, [
          (prefView.value === 'list')
            ? (_openBlock(), _createElementBlock("img", _hoisted_12))
            : _createCommentVNode("", true),
          (prefView.value === 'card')
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : _createCommentVNode("", true),
          (prefView.value === 'card')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Liste Görünümü"))
            : _createCommentVNode("", true),
          (prefView.value === 'list')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Kart Görünümü"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (isAddingPotential.value = true)),
        class: "ac-add-button"
      }, [
        _hoisted_16,
        _createTextVNode(" Yeni Fırsat Ekle ")
      ])
    ]),
    (_unref(isLoadingDocs))
      ? (_openBlock(), _createBlock(SkeletonTable, {
          key: 0,
          class: "col-start-1 col-end-13 w-full",
          width: "100",
          rows: "20"
        }))
      : (!_unref(isLoadingDocs) && prefView.value === 'list')
        ? (_openBlock(), _createBlock(AcDataTable, {
            key: 1,
            onRowClicked: _cache[5] || (_cache[5] = ($event: any) => (navigateToPotential($event))),
            class: "w-full col-start-1 col-end-13",
            data: tableData.value,
            columns: dataCols
          }, {
            "cell-potentialRating": _withCtx(({ value }) => [
              _createVNode(StarDisplay, { "picked-quantity": value }, null, 8, ["picked-quantity"])
            ]),
            "cell-categories": _withCtx(({ value }) => [
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (category) => {
                  return (_openBlock(), _createBlock(modernStatusChip, {
                    key: category.id,
                    text: category.name,
                    bgColors: { [category.id]: category.color },
                    value: category.id,
                    class: "text-sm"
                  }, null, 8, ["text", "bgColors", "value"]))
                }), 128))
              ])
            ]),
            "cell-actions": _withCtx(({ value }) => [
              _createElementVNode("button", {
                class: "ac-table-button",
                onClick: _withModifiers(($event: any) => (handlePotentialMovedToTracked(value)), ["stop"])
              }, " İzlenenlere Taşı ", 8, _hoisted_18)
            ]),
            _: 1
          }, 8, ["data"]))
        : (!_unref(isLoadingDocs) && prefView.value === 'card')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPotentials.value, (potential) => {
                return (_openBlock(), _createBlock(CrmPotentialCard, {
                  key: potential.id,
                  potential: potential,
                  onClick: ($event: any) => (navigateToPotential(potential))
                }, null, 8, ["potential", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingPotential.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44",
                onModalClosed: _cache[7] || (_cache[7] = ($event: any) => (isAddingPotential.value = false)),
                width: "70vw",
                height: "fit-content",
                title: "Yeni Fırsat Ekle"
              }, {
                default: _withCtx(() => [
                  _createVNode(AddPotentialForm, {
                    onPotentialAdded: handlePotentialAdded,
                    onCancel: _cache[6] || (_cache[6] = ($event: any) => (isAddingPotential.value = false))
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})